import type { FunctionComponent } from 'react';
import React from 'react';

/**
 * Car & House Icon - Used in shopfor page
 */
export const CarHouseIcon: FunctionComponent<unknown> = () => {
  return (
    <svg width="30" height="18" viewBox="0 0 30 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.06451 11.3226H12.871" stroke="#0D202F" strokeMiterlimit="10" />
      <path
        d="M14.9355 15.4516H16.4839V11.3226H12.871L10.8065 7.70968H4.6129L3.06452 11.3226H1V15.4516H2.54839"
        stroke="#0D202F"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M5.64517 15.4516H11.8387" stroke="#0D202F" strokeMiterlimit="10" strokeLinecap="square" />
      <path
        d="M4.09679 17C4.95194 17 5.64517 16.3068 5.64517 15.4516C5.64517 14.5965 4.95194 13.9032 4.09679 13.9032C3.24164 13.9032 2.5484 14.5965 2.5484 15.4516C2.5484 16.3068 3.24164 17 4.09679 17Z"
        stroke="#0D202F"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path
        d="M13.3871 17C14.2423 17 14.9355 16.3068 14.9355 15.4516C14.9355 14.5965 14.2423 13.9032 13.3871 13.9032C12.532 13.9032 11.8387 14.5965 11.8387 15.4516C11.8387 16.3068 12.532 17 13.3871 17Z"
        stroke="#0D202F"
        strokeMiterlimit="10"
        strokeLinecap="square"
      />
      <path d="M7.70969 7.70968V11.3226" stroke="#0D202F" strokeMiterlimit="10" />
      <path d="M13.9032 7.19355L21.6452 1L29.3871 7.19355" stroke="#FF3975" strokeMiterlimit="10" />
      <path d="M20.0968 15.4516V11.3226H23.1935V15.4516" stroke="#FF3975" strokeMiterlimit="10" />
      <path d="M27.3226 8.22581V15.4516H19.0645" stroke="#FF3975" strokeMiterlimit="10" strokeLinecap="square" />
    </svg>
  );
};
